/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// You can delete this file if you're not using it
import "./src/styles/global.css"

// Detect Android/mobile and apply performance class
if (typeof window !== "undefined") {
  const isAndroid = /Android/i.test(navigator.userAgent)
  const isMobile = window.innerWidth <= 768
  if (isAndroid || isMobile) {
    document.documentElement.classList.add("no-blur-filter")
  }
}
